import React from "react"
import Link from "./link"
import { Button } from "../styles"

export default ({ to, children, ...props }) => (
  <Link to={to}>
    <Button {...props}>{children}</Button>
  </Link>
)
